import React, { useState, useEffect } from 'react';
import { tieredPackageService, TieredPackage } from '../services/tieredPackageService';
import TieredPackageCard from '../components/Tours/TieredPackageCard';
import { useTheme } from '../contexts/ThemeContext';

const TieredPackages: React.FC = () => {
    const { actualTheme } = useTheme();
    const [packages, setPackages] = useState<TieredPackage[]>([]);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        const loadPackages = async () => {
            setIsLoading(true);
            try {
                const data = await tieredPackageService.getAllPackages(true);
                setPackages(data);
            } catch (error) {
                console.error('Error loading tiered packages:', error);
            } finally {
                setIsLoading(false);
            }
        };

        loadPackages();
    }, []);

    return (
        <div className={`min-h-screen ${actualTheme === 'dark' ? 'bg-slate-900' : 'bg-neutral-50'}`}>
            {/* Hero Section */}
            <div className="bg-primary-800 text-white py-16">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                    <h1 className="text-4xl md:text-5xl font-bold mb-4">Tiered Safari Packages</h1>
                    <p className="text-xl text-white/90 max-w-3xl">
                        Choose your perfect safari experience. From luxury to budget, we offer flexible packages tailored to your preferences.
                    </p>
                </div>
            </div>

            {/* Packages Grid */}
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
                {isLoading ? (
                    <div className="flex justify-center items-center py-20">
                        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary-800" />
                    </div>
                ) : packages.length === 0 ? (
                    <div className="text-center py-20">
                        <h2 className={`text-2xl font-bold mb-4 ${actualTheme === 'dark' ? 'text-white' : 'text-primary-900'}`}>
                            No Packages Available
                        </h2>
                        <p className={actualTheme === 'dark' ? 'text-slate-400' : 'text-neutral-600'}>
                            Check back soon for new safari packages!
                        </p>
                    </div>
                ) : (
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                        {packages.map((pkg) => (
                            <TieredPackageCard key={pkg.id} package={pkg} />
                        ))}
                    </div>
                )}
            </div>
        </div>
    );
};

export default TieredPackages;
